function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

export { rectToClientRect as r };
//# sourceMappingURL=rectToClientRect-BePxUN7v.js.map
